import { Companion_getInstance29ub64y89bvyi as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.r41_1 = operation;
        this.s41_1 = null;
        this.t41_1 = Companion_getInstance().e42_1;
        this.u41_1 = null;
        this.v41_1 = null;
        this.w41_1 = null;
        this.x41_1 = null;
        this.y41_1 = null;
        this.z41_1 = null;
        this.a42_1 = null;
        this.b42_1 = null;
        this.c42_1 = null;
        this.d42_1 = true;
      }
      f42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.s41_1 = requestUuid;
        return this;
      }
      g42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.t41_1 = executionContext;
        return this;
      }
      h42(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.a42_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      i42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.u41_1 = httpMethod;
        return this;
      }
      j42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.v41_1 = httpHeaders;
        return this;
      }
      k42(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.v41_1;
        tmp.v41_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      l42(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.x41_1 = sendApqExtensions;
        return this;
      }
      m42(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.y41_1 = sendDocument;
        return this;
      }
      n42(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.w41_1 = enableAutoPersistedQueries;
        return this;
      }
      o42(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.z41_1 = canBeBatched;
        return this;
      }
      p42(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.b42_1 = retryOnError;
        return this;
      }
      q42(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.c42_1 = failFastIfOffline;
        return this;
      }
      r42(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.d42_1 = sendEnhancedClientAwareness;
        return this;
      }
      c37() {
        var tmp0_elvis_lhs = this.s41_1;
        return new (ApolloRequest())(this.r41_1, tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs, this.t41_1, this.u41_1, this.v41_1, this.x41_1, this.y41_1, this.w41_1, this.z41_1, this.a42_1, this.b42_1, this.c42_1, this.d42_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, executionContext, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.s42_1 = operation;
        this.t42_1 = requestUuid;
        this.u42_1 = executionContext;
        this.v42_1 = httpMethod;
        this.w42_1 = httpHeaders;
        this.x42_1 = sendApqExtensions;
        this.y42_1 = sendDocument;
        this.z42_1 = enableAutoPersistedQueries;
        this.a43_1 = canBeBatched;
        this.b43_1 = ignoreApolloClientHttpHeaders;
        this.c43_1 = retryOnError;
        this.d43_1 = failFastIfOffline;
        this.e43_1 = sendEnhancedClientAwareness;
      }
      f43() {
        return this.g43(this.s42_1);
      }
      g43(operation) {
        return (new (Builder())(operation)).f42(this.t42_1).g42(this.u42_1).i42(this.v42_1).j42(this.w42_1).l42(this.x42_1).m42(this.y42_1).n42(this.z42_1).o42(this.a43_1).p42(this.c43_1).q42(this.d43_1).h42(this.b43_1).r42(this.e43_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
